/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { TrainingJobStore } from 'src/modules/modelTraining/stores/TrainingJobInfoStore';
import { NewTrainingJobSwagger } from 'src/modules/modelTraining/types/trainingSwaggers';
import { calculatePercentComplete } from 'src/modules/modelTraining/utils/trainingUtils';

export const trainingJobInfoSwaggerToTrainingJobInfoStore = (swagger: NewTrainingJobSwagger): TrainingJobStore =>
    new TrainingJobStore(swagger.jobId, {
        modelId: swagger.result.modelLabel,
        trainingMode: swagger.result.trainingMode,
        trainStatus: swagger.result.trainingStatus,
        errors: swagger.errors?.map(e => e.message),
        startDateTime: new Date(swagger.createdDateTime),
        evaluationStatus: swagger.result.evaluationStatus,
        percentComplete: calculatePercentComplete(swagger.result),
        status: swagger.status === 'running' ? 'inProgress' : swagger.status,
        endDateTime: swagger.status === 'succeeded' ? new Date(swagger.lastUpdatedDateTime) : undefined
    });
